import { useContext, useEffect, useCallback, useState } from "react";

import { Context as CampaignsContext } from "../context/CampaignsContext";
import { Context as AuthContext } from "../context/AuthContext";

export default (id, callback = () => {}) => {
  const { subscribeToCampaign: subscribe } = useContext(CampaignsContext);
  const {
    state: { user },
    getMe
  } = useContext(AuthContext);

  const [isUserSubscribed, setSubscription] = useState(false);

  const subscribeToCampaign = useCallback(async () => {
    if (isUserSubscribed) {
      return console.log("El usuario ya está suscrito");
    }
    await subscribe(id, () => callback());
    setSubscription(true);
    getMe();
  }, [subscribe, id, callback, isUserSubscribed, getMe]);

  useEffect(() => {
    getMe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user) {
      setSubscription(
        Boolean(
          user.campaign_subscriptions.filter(e => e.campaign.id === id)
            .length !== 0
        )
      );
    }
  }, [user, id, setSubscription, isUserSubscribed]);

  return [{ isUserSubscribed, subscribeToCampaign }];
};
